import { Avatar, Box, Button, ButtonGroup, CircularProgress, Grid, IconButton, Link, Paper, Table, TableCell, TableContainer, TableHead, TableRow, Typography, TableBody, ButtonBase } from "@mui/material"
import { CenteredBox } from "../../components/layouts/common/boxes"
import { Cancel, CheckBox, CheckCircle, Visibility, Add } from "@mui/icons-material"
import DeleteIcon from '@mui/icons-material/Delete';
import { center } from "../../assets/css/theme/common"
import { Skeleton } from "@mui/material";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../../store/actions/modalAction";
import AddBranchController from "./AddBranchController";
import LaunchIcon from '@mui/icons-material/Launch';
import UpdateBranchController from "./UpdateBranchController";
import DataTable from "../../components/tables/DataTable";

const BranchUI = ({ setState, filters, setFilters, callBack, loading, state, columns }) => {
    const dispatch = useDispatch();
    const addholiday = useCallback(() => {
        dispatch(openModal({
            title: "Add Branch",
            component: <AddBranchController callBack={callBack} />, size: 'sm'
        }))
    }, [])
    const UpdateBranch = useCallback((id, intialName, initialAddress) => {
        dispatch(openModal({
            title: "Update Branch",
            component: <UpdateBranchController callBack={callBack} id={id} intialName={intialName} initialAddress={initialAddress} />, size: 'sm'
        }))
    }, [])
    return <>
        {
            !state && !loading && <CenteredBox><Typography variant="h3">Loading Data...</Typography></CenteredBox>
        }
        <Box m={3}>
            <Box>
                <Typography sx={{
                    fontWeight: 700,
                    fontSize: "24px",
                    lineHeight: "40px",
                    color: "#0D0D0D"
                }}>Branch</Typography>
                <Button onClick={addholiday} sx={{
                    display: "flex",
                    height: "100%",
                    zIndex: 0,
                    textTransform: "capitalize",
                    boxShadow: "none",
                    border: "1px solid #393939",
                    width: "100%",
                    height: "56px",
                    ":hover": {
                        boxShadow: "none"
                    }
                }}>
                    <Add color="primary" /> &nbsp;Add Branch
                </Button>
            </Box>
            <Box sx={{ minHeight: "300px" }} mt={3}>
                <DataTable columns={columns} rows={state} count={state?.length} filters={filters} setFilters={setFilters} loading={loading} />
            </Box>
        </Box>
    </>
}
export default BranchUI